import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { API_BASE_URL } from "../utils/constants";
import { authUrl } from "../utils/auth";

// Bank / lot picker + Excel download for the lawyer's stage uploads (SOC, Section 17 application).
// Lists only lots with cases still pending that stage; the Excel holds just that lot's pending cases.
const PendingLotExcelDownload = ({ pendingPath, excelPath }) => {
  const [lots, setLots] = useState([]);
  const [selected, setSelected] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${API_BASE_URL}${pendingPath}`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`Request failed (${res.status})`))))
      .then(setLots)
      .catch((e) => setError(`Could not load pending lots: ${e.message}`));
  }, [pendingPath]);

  const handleDownload = () => {
    const lot = lots[Number(selected)];
    if (!lot) return;
    const query = `Lot_no=${lot.Lot_no}&Client_id=${lot.Client_id}&Product_id=${lot.Product_id}`;
    window.open(authUrl(`${API_BASE_URL}${excelPath}?${query}`), "_blank");
  };

  return (
    <div className="d-flex gap-2 align-items-center">
      <Form.Select
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
        className="custom_input"
        style={{ fontSize: "12px" }}
        aria-label="Bank / lot to download"
      >
        <option value="">{lots.length ? "Choose bank / lot…" : "No pending lots"}</option>
        {lots.map((lot, index) => (
          <option key={`${lot.Lot_no}-${lot.Client_id}-${lot.Product_id}`} value={index}>
            {lot.Lots} ({lot.Pending} pending)
          </option>
        ))}
      </Form.Select>
      <button
        className="custBtn"
        onClick={handleDownload}
        disabled={selected === ""}
        style={{ fontSize: "12px", whiteSpace: "nowrap" }}
      >
        ⬇ Download Excel
      </button>
      {error && <small className="text-danger">{error}</small>}
    </div>
  );
};

export default PendingLotExcelDownload;
